import axios from "axios";
import router from "./router";
import Element from "element-ui";

const request = axios.create({
  timeout: 60000,
  headers: {
    "Content-Type": "application/json; charset=utf-8"
  }
});

request.interceptors.request.use(config => {
  config.headers["token"] = localStorage.getItem("token");
  return config;
});

request.interceptors.response.use(
  response => {
    const url = (response && response.config && response.config.url) || "";
    const ok = response && response.data && response.data.code === 200;
    const special = url.includes("/assign/phone/assign");
    if (ok || special) {
      return response;
    }
    const msg = (response && response.data && response.data.msg) || "系统异常";
    if (msg !== "请先登录") {
      Element.Message.error(msg);
    }
    if (url.includes("/login")) {
      return response;
    }
    return Promise.reject(new Error(msg));
  },
  error => {
    const status = error && error.response && error.response.status;
    const url = error && error.config && error.config.url;
    const msg =
      (error &&
        error.response &&
        error.response.data &&
        (error.response.data.msg || error.response.data.message)) ||
      error.message ||
      "系统异常";
    if (status === 401) {
      localStorage.clear();
      if (!router.currentRoute || router.currentRoute.path !== "/login") {
        router.replace("/login").catch(() => {});
      }
      return new Promise(() => {});
    }
    Element.Message.error(msg, { duration: 3000 });
    return Promise.reject(new Error(msg));
  }
);

export default request;



// WEBPACK FOOTER //
// ./src/axios.js